// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"cf6d9621","164":"61a4e678","410":"44ce9ef8","453":"248a7db4"}[chunkId] + ".chunk.js";
};